import { render, staticRenderFns } from "./PageForm.vue?vue&type=template&id=7a8a73b7&scoped=true"
import script from "./PageForm.vue?vue&type=script&lang=js"
export * from "./PageForm.vue?vue&type=script&lang=js"
import style0 from "./PageForm.vue?vue&type=style&index=0&id=7a8a73b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8a73b7",
  null
  
)

export default component.exports